import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { ReviewCard, StarSummary } from "@/components/ReviewCard";

export default function ReviewsPage() {
  const { data: reviews = [], isLoading } = useQuery({ queryKey: ["reviews"], queryFn: async () => (await api.get("/reviews")).data });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="reviews-page">
      <p className="text-xs font-mono-p uppercase tracking-widest text-[#ff6a13]">Customer love</p>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-white mt-2">Reviews</h1>
      <StarSummary reviews={reviews} />

      {isLoading ? (
        <p className="text-zinc-500 font-mono-p mt-10">Loading reviews…</p>
      ) : reviews.length === 0 ? (
        <p className="text-zinc-400 mt-10">No reviews yet — check back soon!</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
          {reviews.map((r) => <ReviewCard key={r.review_id} r={r} />)}
        </div>
      )}
    </div>
  );
}
